var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3H10.875C9.63398 3 8.625 4.00723 8.625 5.25V13.125C8.625 14.3678 9.63223 15.375 10.875 15.375H18.75C19.9928 15.375 21 14.3678 21 13.125V5.25C21 4.00723 19.991 3 18.75 3ZM19.3125 13.125C19.3125 13.4351 19.0601 13.6875 18.75 13.6875H10.875C10.5656 13.6875 10.3125 13.4344 10.3125 13.125V5.25C10.3125 4.93985 10.5649 4.6875 10.875 4.6875H18.75C19.0601 4.6875 19.3125 4.93985 19.3125 5.25V13.125ZM13.6875 18.75C13.6875 19.0601 13.4351 19.3125 13.125 19.3125H5.25C4.93985 19.3125 4.6875 19.0601 4.6875 18.75V10.875C4.6875 10.5649 4.93985 10.3125 5.25 10.3125H7.5V8.625H5.25C4.00723 8.625 3 9.63398 3 10.875V18.75C3 19.9928 4.00723 21 5.25 21H13.125C14.3678 21 15.375 19.9928 15.375 18.75V16.5H13.6875V18.75Z",
    fill: "#E6ECEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.624af4a96cb57c0a4132b43aaa87bcaf.svg";
export { ForwardRef as ReactComponent };